import React, { FC } from 'react';

import { UserPage } from '../../components/UserPage';
import { Section } from '../../components/Section';


export const GeolocationHelpPage: FC = () => {
    return (
        <UserPage title="Salon.jp | マップとは">
            <Section>
                <div className="title">
                    <h1>位置情報の利用を許可する方法</h1>
                </div>
                <div className="content">
                    <div className="label">
                        <span>iOS ご利用の方</span>
                    </div>
                    <ol className="description">
                        <li>ホーム画面の [設定] をタップします</li>
                        <li>[プライバシー] をタップします</li>
                        <li>[位置情報サービス] をタップします</li>
                        <li>[位置情報サービス]、[Salon.jp(アプリご利用の場合)]、[Safari]、[Facebook]、の項目を「オン」にします</li>
                    </ol>
                </div>
                <div className="content">
                    <div className="label">
                        <span>Android ご利用の方</span>
                    </div>
                    <ol className="description">
                        <li>ホーム画面の [設定] をタップします</li>
                        <li>[位置情報] をタップします</li>
                        <li>[位置情報サービス] をタップします</li>
                        <li>[位置情報]、[Salon.jp(アプリご利用の場合)]、[Facebook]、の項目を「オン」または「許可」の欄に追加にします<br />※ お使いのブラウザアプリがあればそちらも「オン」または「許可」します</li>
                    </ol>
                </div>
                <div className="content">
                    <div className="label">
                        <span>PC ご利用の方</span>
                    </div>
                    <details>
                        <summary>Chromeの設定方法</summary>
                        <ol className="description">
                            <li>右上のその他アイコン [設定] をクリックします</li>
                            <li>[プライバシーとセキュリティ] の [サイトの設定] をクリックします</li>
                            <li>[位置情報] をクリックします</li>
                            <li>[位置情報を要求できるようにする]、または[アクセスする前に確認する]を「オン」にします<br />※ もし[位置情報の取得を許可しないサイト]、[ブロック] に https://salon.jp が設定されていたら右のゴミ箱アイコンをクリックします</li>
                        </ol>
                    </details>
                    <details>
                        <summary>Safariの設定方法</summary>
                        <ol className="description">
                            <li>アドレスバー左上の[Safari]をクリックします</li>
                            <li>[環境設定]をクリックします</li>
                            <li>[位置情報]の[現在開いているWebサイト]にsalon.jp が表示されていることを確認し、「許可」をクリックします</li>
                        </ol>
                    </details>
                </div>
            </Section>

            <style jsx>{`
                .title {
                    padding-top: 50px;
                    padding-bottom: 26px;
                }
                .content {
                    margin-bottom: 24px;
                }
                .content:nth-last-child(1) {
                    padding-bottom: 24px;
                    margin-bottom: 0px;
                }
                h1 {
                    font-weight: normal;
                    font-size: 20px;
                    margin: 0;
                }
                .label {
                    margin: 0;
                    margin-bottom: 8px;
                    border-left: solid 4px #ccc;
                    padding-left: 8px;
                    height: 22px;
                    display: flex;
                    justify-content: start;
                    align-items: center;
                }
                .label > span {
                    font-size: 20px;
                    font-weight: bold;
                }
                .description {
                    list-style-position: inside;
                    background: #e0ffff;
                    padding: 12px;
                    font-size: 14px;
                }
                .description > li {
                    margin-bottom: 8px;
                }
                details {
                    margin-bottom: 10px;
                }
                summary {
                    cursor: pointer;
                }
                a,
                p {
                    font-size: 16px;
                    margin: 0;
                }
                a {
                    color: #fe8125;
                }
                @media screen and (max-width: 540px) {
                    .title {
                        padding-top: 24px;
                        padding-bottom: 36px;
                    }
                    .label > span {
                        font-size: 18px;
                    }
                    a,
                    p {
                        font-size: 14px;
                    }
                }
            `}</style>
        </UserPage>
    );
};
